import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-gift-icon',
  templateUrl: './shopping-gift.component.html'
})
export class ShoppingGiftComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
